import {i18nFormat} from "../../lib/i18nFormat";
import {Backup} from "./Backup";
import React, {useMemo} from "react";
import PropTypes from "prop-types";

export function BackupsSection(props) {
  const backups = useMemo(() => {
    return props.homey.backups.sort((a, b) => {
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
  }, [props.homey.backups]);

  return (
    <div className="account-backups-section">
      <h2 className="account-backups-section__header">{props.homey.name}</h2>
      <div className="account-backups-section__list-header">
        <span className="account-backups-section__list-header-item">{i18nFormat("backups.version")}</span>
        <span className="account-backups-section__list-header-item">{i18nFormat("backups.date")}</span>
      </div>
      <div className="account-backups-section__list-container">
        {backups.map(backup => (
          <Backup
            key={backup.backupId}
            backup={backup}
            onDelete={props.onDelete}
          />
        ))}
      </div>
    </div>
  )
}

BackupsSection.propTypes = {
  homey: PropTypes.shape({
    name: PropTypes.string.isRequired,
    backups: PropTypes.arrayOf(PropTypes.shape({
      backupId: PropTypes.string.isRequired,
      version: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
};